import React from 'react'
import { useSelector } from 'react-redux'

import {
  currentNumberSelector,
  lengthSelector,
} from '@/services/slices/questionSlice'

import styles from './QuestionCounter.module.scss'

import {
  IconDone,
  Icon_opt_1,
  Icon_opt_10,
  Icon_opt_2,
  Icon_opt_3,
  Icon_opt_4,
  Icon_opt_5,
  Icon_opt_6,
  Icon_opt_7,
  Icon_opt_8,
  Icon_opt_9,
} from '../icons/questionIcons'

const QuestionCounter = () => {
  const defaultIconList = [
    <Icon_opt_1 />,
    <Icon_opt_2 />,
    <Icon_opt_3 />,
    <Icon_opt_4 />,
    <Icon_opt_5 />,
    <Icon_opt_6 />,
    <Icon_opt_7 />,
    <Icon_opt_8 />,
    <Icon_opt_9 />,
    <Icon_opt_10 />,
  ]

  const greenIconList = [
    <Icon_opt_1 />,
    <Icon_opt_2 current />,
    <Icon_opt_3 current />,
    <Icon_opt_4 current />,
    <Icon_opt_5 current />,
    <Icon_opt_6 current />,
    <Icon_opt_7 current />,
    <Icon_opt_8 current />,
    <Icon_opt_9 current />,
    <Icon_opt_10 current />,
  ]

  const currentId = useSelector(currentNumberSelector)
  const questionsCount = useSelector(lengthSelector)

  return (
    <div className={styles.wrapper}>
      {defaultIconList.slice(0, questionsCount).map((icon, index) => {
        if (index < currentId - 1) {
          return (
            <React.Fragment key={index}>
              <IconDone />
            </React.Fragment>
          )
        } else if (index === currentId - 1) {
          return (
            <React.Fragment key={index}>{greenIconList[index]}</React.Fragment>
          )
        }
        return <React.Fragment key={index}>{icon}</React.Fragment>
      })}
    </div>
  )
}

export default QuestionCounter
